import type { TypeResolvedFeatures } from '../types';
import type { TypeUploadFeature } from '../core/types';

// ----------------------------------------------------------------------------

/*
 * Drops files the caller does not want sent — a size cap, an extension check, anything.
 *
 * The thinnest feature there is, and the reason `fnShouldSend` exists as its own extension point:
 * the decision happens before there is an attempt to wrap or a request to observe, and its outcome
 * is `skipped`, which is neither a success nor an error.
 */
function createFilterFeature(features: TypeResolvedFeatures): TypeUploadFeature | null {
    const { enabled, fn } = features.filter;

    if (!enabled || typeof fn !== 'function') {
        return null;
    }

    return {
        name: 'filter',
        fnShouldSend: fn,
    };
}

// ----------------------------------------------------------------------------

export default createFilterFeature;
